import { defineStore } from 'pinia'
import { supabase } from '../services/supabase'

export const isAdminUser = (user: any) => user?.app_metadata?.role === 'admin'

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      userName: '',
      email: '',
      memberSince: '',
      pfp: 'https://picsum.photos/id/22/200/300',
      is2FAEnabled: false,
      session: null as any,
      user: null as any,
    }
  },

  actions: {
    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },

    changeUserName(userName: string) {
      this.userName = userName
    },

    async login(email: string, password: string) {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      })

      if (error) {
        throw error
      }

      if (data.user && !isAdminUser(data.user)) {
        await supabase.auth.signOut()
        throw new Error('Access denied: Admin privileges required.')
      }

      this.session = data.session
      this.user = data.user
      this.email = data.user?.email || ''
    },

    async logout() {
      const { error } = await supabase.auth.signOut()

      if (error) {
        throw error
      }

      this.session = null
      this.user = null
      this.email = ''
      this.userName = ''
    },

    async fetchSession() {
      const { data, error } = await supabase.auth.getSession()

      if (error) {
        throw error
      }

      const user = data.session?.user
      if (user && !isAdminUser(user)) {
        await supabase.auth.signOut()
        this.session = null
        this.user = null
        this.email = ''
        return
      }

      this.session = data.session
      this.user = user || null
      if (this.user) {
        this.email = this.user.email || ''
      }
    },
  },
})
